export const NotFound = () => <p>404 page not found</p>;
